import React from 'react';

import { StyledTextRow } from './styles';
import { TextProps } from './types';

/** Skeleton for text components */
export const Text: React.FC<TextProps> = ({ rows = 3 }) => {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <StyledTextRow key={i} data-testid={`skeleton--text--row-${i}`} />
      ))}
    </>
  );
};
